export const queryKeys = {
  register: ['register'] as const,
  categories: ['categories'] as const,
  products: (params: object) => ['products', params] as const,
  customers: (search: string) => ['customers', search] as const,
  orders: (search: string, shift = false) => ['orders', search, shift] as const,
}
